import { Component, OnInit, ViewEncapsulation, Input } from "@angular/core";
import { PartnerNamesEnum } from '../shared';

@Component({
    selector: 'app-footer',
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class FooterComponent implements OnInit {
    @Input() partnerName: string = "";
    PartnerNamesEnum = PartnerNamesEnum;

    get isPartnerPage() {
        return this.partnerName && this.partnerName.length;
    }

    get fullYear() {
        return new Date().getFullYear();
    }

    constructor() { }

    ngOnInit(): void {
    }
}
